export default "__VITE_ASSET__rw3yIgZH__"